import React, { useEffect, useState } from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import { GetappointmentsbyPut } from "../../../../api/helper";
import { useNavigate } from "react-router-dom";
function PatinetAppointmnetList() {
  const profileData = useSelector((state) => state?.cookies?.userDetails);
  const navigate = useNavigate();

  const [appointmanetList, setAppointmentList] = useState([]);
  const getAppointmentresponse = async () => {
    try {
      const response = await GetappointmentsbyPut({
        patientId: profileData._id,
      });
      setAppointmentList(response.data.data.appointments);
    } catch (error) {
      console.log(error, "====>error");
    }
  };

  useEffect(() => {
    getAppointmentresponse();
  }, []);

  return (
    <table className="appointments-table_CalendarView">
      <thead>
        <tr>
          <th>SessionID</th>
          <th>Client</th>
          <th>Provider</th>
          <th>Type</th>
          <th>Payment Method</th>
          <th>Duration</th>
          {/* <th>Billing Unit</th> */}
          <th>SubTotal</th>
          <th>Visit Reason</th>
          <th>Date</th>
          <th>Location</th>
          <th>PA Number</th>
          <th>Ref. NPI</th>
          <th>Status</th>
          <th>Create Note</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {(appointmanetList?.length ?? 0) === 0 ? (
          <tr>
            <td colSpan="16" style={{ textAlign: "center", padding: "20px" }}>
              No matching appointments found.
            </td>
          </tr>
        ) : (
          appointmanetList?.map((app, idx) => {
            const patientName =
              [
                app?.patientRequestId?.firstName,
                app?.patientRequestId?.lastName,
              ]
                .filter(Boolean)
                .join(" ") || "Unknown";

            const doctorName =
              [app?.doctorRequestId?.firstName, app?.doctorRequestId?.lastName]
                .filter(Boolean)
                .join(" ") || "Unknown";

            const dateStr =
              app?.date && moment(app.date).isValid()
                ? moment(app.date).format("DD/MM/YYYY")
                : "—";

            const statusName = app?.appointmentStatus?.name ?? "Pending";
            const statusColor = app?.appointmentStatus?.color ?? "#6b7280";

            return (
              <tr key={app?._id ?? idx}>
                <td>{app?._id?.slice?.(-7) ?? "—"}</td>

                <td
                  style={{
                    cursor: app?.patientRequestId ? "pointer" : "default",
                  }}
                  // onClick={() =>
                  //   app?.patientRequestId &&
                  //   navigation("/ClientEditbyagency", {
                  //     state: { data: app.patientRequestId },
                  //   })
                  // }
                >
                  {patientName}
                </td>

                <td
                  style={{
                    cursor: app?.doctorRequestId ? "pointer" : "default",
                  }}
                  // onClick={() =>
                  //   app?.doctorRequestId &&
                  //   navigation("/DoctorDetailsclinic", {
                  //     state: { data: app.doctorRequestId },
                  //   })
                  // }
                >
                  {doctorName}
                </td>

                <td>{app?.deliveryMode?.name ?? "—"}</td>
                <td>{app?.paymentSource ?? "—"}</td>
                <td>{app?.Duration ?? "—"}</td>
                {/* <td>2</td> */}
                <td>$150.00</td>
                <td>{app?.visitReason?.visitReason ?? "—"}</td>
                <td>{dateStr}</td>
                <td>{app?.serviceLocationId?.name ?? "—"}</td>
                <td>{app?.authorizationDetailId?.Auth ?? "Not Available"}</td>
                <td>{app?.somePhoneField ?? "999999999"}</td>

                <td className="custom-action-td">
                  <div className="custom-dropdown">
                    <button className="custom-action-button" type="button">
                      <span
                        className="status-badge_two"
                        style={{ background: statusColor, color: "white" }}
                      >
                        {statusName}
                      </span>
                      {/* <i className="fas fa-ellipsis-v" /> */}
                    </button>
                  </div>
                </td>
                <td>📝 Notes</td>
                <td className="custom-action-td">
                  <div className="custom-dropdown">
                    <button className="custom-action-button" type="button">
                      <span
                        className="status-badge_two"
                        style={{ background: "#6c757d", color: "white" }}
                      >
                        ⚙️ Actions
                      </span>
                      <i className="fas fa-ellipsis-v" />
                    </button>

                    <div className="custom-dropdown-menu">
                      <ul>
                        <li>
                          <button
                            className="custom-dropdown-item"
                            type="button"
                            onClick={() =>
                              navigate("/AppointmentspatientsDetail", {
                                state: { app },
                              })
                            }
                          >
                            View Details
                          </button>
                        </li>
                        {/* <li>
                          <button
                            className="custom-dropdown-item"
                            type="button"
                          >
                            Other Action
                          </button>
                        </li> */}
                      </ul>
                    </div>
                  </div>
                </td>
              </tr>
            );
          })
        )}
      </tbody>
    </table>
  );
}

export default PatinetAppointmnetList;
